import React, { useContext } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Box, Typography, useMediaQuery, useTheme, Divider, } from "@mui/material"
import { useLocation, useNavigate } from 'react-router-dom'
import fondo from '../img/campus.webp'
import { motion, AnimatePresence } from "framer-motion";
import { Facebook, Twitter, YouTube, LinkedIn, Instagram, Pinterest } from '@mui/icons-material';
import TokenContext from '../context/TokenContext'
import { misMensajes } from '../Redux/mensajes';
import { UserAuth } from '../context/AuthContext'; //IMPORTO PARA ACCEDER AL ESTADO DONDE ALMACENE PREVIAMENTE EL ID DEL EMPLEADO Y EL USUARIOPORTAL

// Importa la instancia de analytics desde tu archivo 'firebaseConfig'
import { analytics } from '../Firebase'
import { Icon } from '@iconify/react';

const Inicio = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const location = useLocation();
    const theme = useTheme()
    const token = useContext(TokenContext)
    const isNonMobile = useMediaQuery("(min-width: 1000px)");
    const mensajesSelector = useSelector(store => store.mensajes.mensajes)
    const loadingMensajesSelector = useSelector(store => store.mensajes.loadingMensajes)
    const { empleado } = UserAuth() //empleado contiene el usuarioPortalRh y empleadoid, esos dos valores son necesarios para las consultas a los fetch.

    const [mensajes, setMensajes] = React.useState([])
    const [loading, setLoading] = React.useState([])

    React.useEffect(() => {
        if (empleado && empleado.usuarioPortalRh) {
            // Extraer el nombre de usuario de la dirección de correo electrónico
            const userEmail = empleado.usuarioPortalRh;
            const userName = userEmail.split('@')[0];
    
            // Enviar el evento a Firebase Analytics con el nombre de usuario
            analytics.logEvent('screen_view', {
                screen_name: location.pathname,
                user_email: userName,
            });
        }
    }, [empleado, location]);

    React.useEffect(() => {
        if (token && empleado) {
            dispatch(misMensajes(token, empleado.usuarioPortalRh))
        }
    }, [token, empleado])

    React.useEffect(() => {
        setLoading(loadingMensajesSelector)
    }, [loadingMensajesSelector])

    React.useEffect(() => {
        if (mensajesSelector.length > 0) {
            setMensajes(mensajesSelector)
        }
    }, [mensajesSelector])

    return (
        <motion.div
            initial={{ opacity: 0, y: 100 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -100 }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
        >
            <Box
            // m="1.5rem 2.5rem"
            >
                {/* <Header title={"Inicio"} subtitle="Bienvenido" /> */}
                <Box
                    sx={{
                        position: "relative",
                        height: "100vh",
                        overflow: "hidden",
                    }}
                >
                    <Box
                        sx={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            backgroundImage: `url(${fondo})`,
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            backgroundColor: "#000000",
                            opacity: theme.palette.mode === "dark" ? 0.9 : 0.7,
                            zIndex: -1,
                            position: "relative", // Agregar una posición relativa para que los elementos internos se posicionen sobre el fondo
                            filter: theme.palette.mode === "dark" ? "opacity(0.4)" : "brightness(1) opacity(1)", // Aplicar un filtro de opacidad y brillo dependiendo del modo del tema
                        }}
                    ></Box>


                    <Box
                        sx={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            textAlign: "center",
                            zIndex: 1,
                        }}
                    >
                        <AnimatePresence mode="wait">
                            <motion.div
                                initial={{ opacity: 0, y: -50 }}
                                animate={{ opacity: 1, y: 0 }}
                                exit={{ opacity: 0, y: 50 }}
                                transition={{ duration: 0.5, delay: 0.25 }}
                            >
                                <Typography variant="h2" sx={{ fontWeight: "bold", mb: 2, }}>
                                    PORTAL DE GESTIÓN
                                </Typography>

                                <Typography variant="body1" sx={{ mb: 2, fontWeight: 'bold' }}>
                                Te damos la bienvenida a nuestro Portal Codocente. Una plataforma de autogestión que te permite realizar solicitudes y consultas a Gestión Humana, y gestionar tu desarrollo a través del módulo de Gestión de Desempeño y Universidad Interna.
                                </Typography>

                                {/* <Typography variant="body1" sx={{ mb: 2, fontWeight: 'bold' }}>
                                    En esta página encontrarás un resumen de tus actividades.
                                </Typography> */}
                                {/* <Box sx={{ mt: 4 }}>

                                    <div className="contenedor-scroll">
                                        <div className="field">
                                          
                                            <div className="scroll"></div>
                                            
                                        </div>
                                    </div>
                                </Box> */}
                            </motion.div>
                        </AnimatePresence>
                    </Box>

                </Box>

                <Box
                    m="1.5rem 2.5rem"
                    id="saludo"
                >
                    {/* <Box sx={{
                        mb: 4, display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                    }}>
                        <Typography variant="h3" sx={{ fontWeight: "bold" }}>
                            Hola Sebastián!
                        </Typography>
                        <Typography variant="h5" sx={{ mb: 2, mt: 2 }}>
                            Si deseas revisar, estos son los últimos mensajes:
                        </Typography>

                    </Box> */}

                    {/* <Card sx={{ backgroundColor:  theme.palette.mode === 'dark' ? theme.palette.primary.main  : theme.palette.tertiary[600] }}>
                        <CardHeader
                            title={
                                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: '#fff' }}>
                                  Mensajes
                                </Typography>
                              }
                            subheader={
                                <Typography variant="subtitle2" sx={{ fontWeight: 'lighter', color: '#fff' }}>
                                  últimos recibidos
                                </Typography>
                              }
                            />          
                        <Divider />
                        {
                            loading ? (
                                <Box
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        width: '100%',
                                        height: '100%',
                                        py: 2
                                    }}>
                                    <CircularProgress />
                                </Box>
                            )
                                : mensajes.length > 0 ? (
                                    <Timeline sx={{
                                        [`& .${timelineOppositeContentClasses.root}`]: {
                                            flex: 0.2,
                                        },
                                    }}>

                                        {mensajes.map((mensaje) => (
                                            <TimelineItem key={mensaje.activityid}>
                                                <TimelineOppositeContent
                                                    sx={{ m: 'auto 0' }}
                                                    align="right"
                                                    variant="body1"
                                                    color="text.secondary"
                                                >
                                                    {mensaje["statuscode@OData.Community.Display.V1.FormattedValue"]}
                                                </TimelineOppositeContent>
                                                <TimelineSeparator>
                                                    <TimelineConnector />
                                                    <TimelineDot color="primary">
                                                        <MessageIcon color="secondary" />
                                                    </TimelineDot>
                                                    <TimelineConnector />
                                                </TimelineSeparator>
                                                <TimelineContent sx={{ py: '12px', px: 2, }}>
                                                    <Typography variant="h6" component="span" sx={{ fontWeight: 'bold', color: '#fff' }}>
                                                        Mensaje:
                                                    </Typography>
                                                    <Typography sx={{ color: '#fff', fontWeight: 'light' }}>{mensaje.description}</Typography>
                                                </TimelineContent>
                                            </TimelineItem>
                                        ))}
                                    </Timeline>
                                ) :
                                    <Alert severity="info">
                                        <AlertTitle>Info</AlertTitle>
                                        No tienes registros de — <strong>Mensajes</strong>.
                                    </Alert>

                        }


                    </Card> */}
                </Box>

                <Divider sx={{ mt: 2, mb: 2 }} />
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                    <Typography variant="h7">
                        Síguenos en nuestras redes sociales:
                    </Typography>
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mt: 2 }}>
                        <motion.div
                            whileHover={{ scale: 1.2, color: '#4867AA' }}
                            animate={{ rotate: 360 }}
                            transition={{ duration: 0.5 }}
                        >
                            <a href="https://www.facebook.com/lasiglo21" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: 'inherit' }}>
                                <Facebook sx={{ mx: 1 }} />
                            </a>
                        </motion.div>
                        <motion.div
                            whileHover={{ scale: 1.2, color: '#217DBF' }}
                            animate={{ rotate: 360 }}
                            transition={{ duration: 0.5 }}
                        >
                            <a href="https://twitter.com/LaSiglo21" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: 'inherit' }}>
                                <Twitter sx={{ mx: 1 }} />
                            </a>
                        </motion.div>
                        <motion.div
                            whileHover={{ scale: 1.2, color: '#FF0000' }}
                            animate={{ rotate: 360 }}
                            transition={{ duration: 0.5 }}
                        >
                            <a href="https://www.youtube.com/c/universidadsiglo21" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: 'inherit' }}>
                                <YouTube sx={{ mx: 1 }} />
                            </a>
                        </motion.div>
                        <motion.div
                            whileHover={{ scale: 1.2, color: '#0073B2' }}
                            animate={{ rotate: 360 }}
                            transition={{ duration: 0.5 }}
                        >
                            <a href="https://www.linkedin.com/school/lasiglo21/" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: 'inherit' }}>

                                <LinkedIn sx={{ mx: 1 }} />
                            </a>
                        </motion.div>
                        <motion.div
                            whileHover={{ scale: 1.2, color: '#A42EB7' }}
                            animate={{ rotate: 360 }}
                            transition={{ duration: 0.5 }}
                        >
                            <a href="https://www.instagram.com/lasiglo21/" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: 'inherit' }}>

                                <Instagram sx={{ mx: 1 }} />
                            </a>
                        </motion.div>
                        <motion.div
                            whileHover={{ scale: 1.2, color: '#1ED760' }}
                            animate={{ rotate: 360 }}
                            transition={{ duration: 0.5 }}
                        >
                            <Box sx={{mx:1}}>

                            <a href="https://open.spotify.com/user/lasiglo21" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: 'inherit' }}>
                                <Icon icon="mdi:spotify" fontSize={"1.2857142857142856rem"} />
                            </a>
                            </Box>
                        </motion.div>
                        <motion.div
                            whileHover={{ scale: 1.2, color: '#000' }}
                            animate={{ rotate: 360 }}
                            transition={{ duration: 0.5 }}
                        >
                            <Box sx={{mx:1}}>

                            <a href="https://www.tiktok.com/@lasiglo21" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: 'inherit' }}>
                                <Icon icon="ri:tiktok-fill" fontSize={"1.2857142857142856rem"} />
                            </a>
                            </Box>
                        </motion.div>
                    </Box>
                </Box>

            </Box >
        </motion.div>
    )
}

export default Inicio